/* tslint:disable:object-literal-shorthand */
import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {IExgTab} from 'exc-tab-v2';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {ExgDataListComponent, ExgDataTableComponent, ExgModalService, ExgPopupComponent} from 'exc-controls-v2';
import {ExgTabV2Component, ExgTabV2ComponentHeaderElement} from '../../misc/exg-tab-v2/exg-tab-v2.component';
import {EnumerationService} from '../../services/enumeration.service';
import {NestedTreeControl} from '@angular/cdk/tree';
import {ApplicationService} from '../../services/application.service';
import {IExgEvent} from '../../misc/interfaces/IExgEvent';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {DataService} from '../../services/data.service';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ICaseSummaryData} from '../../misc/interfaces/ICaseSummaryData';
import {ExcSecurityService} from 'exc-security-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';
import {ExgFilterChipsComponent} from '../../misc/exg-filter-chips/exg-filter-chips.component';
import {BehaviorSubject} from 'rxjs';
import {ExgTextareaInputComponent} from '../../misc/exg-textarea-input/exg-textarea-input.component';
import {CaseDataService} from '../../services/case-data.service';

@Component({
  selector: 'app-case-workspace',
  templateUrl: './case-workspace-v2.component.html',
  styles: []
})
export class CaseWorkspaceV2Component extends ExcTranslation implements OnInit, IExgTab, IExgEvent {

//#endregion CaseSummary

  @ViewChild('VCcaseTable', {read: ExgDataTableComponent})
  VCcaseTable!: ExgDataTableComponent;
  @ViewChild('VCcaseTableFilterControl', {read: ExgFilterComponent})
  VCcaseTableFilterControl!: ExgFilterComponent;
  @ViewChild('VCrightTabControl', {read: ExgTabV2Component})
  VCrightTabControl!: ExgTabV2Component;
  @ViewChild('VCtaskList', {read: ExgDataListComponent})
  VCtaskList!: ExgDataListComponent;
  @ViewChild('VCreceiptList', {read: ExgDataListComponent})
  VCreceiptList!: ExgDataListComponent;
  @ViewChild('VCreceiptListFilterControl', {read: ExgFilterComponent})
  VCreceiptListFilterControl!: ExgFilterComponent;
  @ViewChild('VCprocessTable', {read: ExgDataListComponent})
  VCprocessTable!: ExgDataListComponent;
  @ViewChild('VCcaseTablePrefilterPopup', {read: ExgPopupComponent})
  VCcaseTablePrefilterPopup!: ExgPopupComponent;
  @ViewChild('VCcasePagerFilterControl', {read: ExgFilterComponent})
  VCcasePagerFilterControl!: ExgFilterComponent;
  @ViewChild('VCcaseTableSearchControl', {read: ExgFilterComponent})
  VCcaseTableSearchControl!: ExgFilterComponent;
  @ViewChild('VCcaseTableSortControl', {read: ExgFilterComponent})
  VCcaseTableSortControl!: ExgFilterComponent;
  @ViewChild('VCFilterChips', {read: ExgFilterChipsComponent})
  VCFilterChips!: ExgFilterChipsComponent;
  @ViewChild('VCValueText', {read: ExgTextareaInputComponent})
  VCValueText!: ExgTextareaInputComponent;

  @ViewChild('DivDetails', {read: ElementRef}) DivDetails!: ElementRef;
  @ViewChild('DivDetails2', {read: ElementRef}) DivDetails2!: ElementRef;
  @ViewChild('DivVerlauf', {read: ElementRef}) DivVerlauf!: ElementRef;
  @ViewChild('VCcaseEdit', {read: ElementRef}) VCcaseEdit!: ElementRef;

  Events = new ExgApplicationEventEmitter();

  Data: any;
  tabinstance: any;
  auCHK = 0;
  editMode = false;
  uiModel: any = {
    auID: '',
    au_enmIdent_AuftragTyp: 0,
    auMdtOKZ: '',
    auOKZ: '',
    aue_enmIdent_Versicherungsart: 0,
    aueVersicherungSumme: 0.0,
    aueWert1914: 0.0,
    aueSelbstbehalt: 0.0,
    aueHinweiseEntschaedigungsgrenze: '',
    aueReserveVU: 0.0,
    aueReserve: 0.0,
    aueSchadensumme: 0.0,
    aueRegulierungsumme: 0.0,
    aueEinsparbetrag: 0.0,
    aueLeistungsgegenstand: '|0|',
    aueRegressmoeglichkeit_enmIdent: 0,
    aueAuftragsdatum: undefined,
    aueOrtsterminPlan: undefined,
    aueKontaktaufnahme: undefined,
    aueOrtstermin: undefined,
    aueOrtstermin2: undefined,
    aueWeitereOrtstermine: '',
    aueFristverlaengerungBis: undefined,
    aueReklamation_enmIdent: 0,
    aueZwischenberichtDatum: undefined,
    aueAbschlussdatum: undefined,
    aueAbrechnungshinweis_enmIdent: 0,
    aueAbrechnungshinweisSub1_enmIdent: 0,
    aueAbrechnungshinweisSub1_enmName: '',
    aueAbrechnungshinweisDatum: undefined,
    aueSchadenNr: '',
    aue_adrID_SchadenOrt: '00000000-0000-0000-0000-000000000000',
    aueSchadenDatum: undefined,
    aueSchadenmeldungVU: undefined,
    aue_enmIdent_SchadenArt: 0,
    aue_enmIdent_SchadenUrsache: 0,
    aue_enmName_SchadenUrsache: '',
    auBeschreibung: ''
  };
  uiSchadenort: any;

  // disable pages Case
  rightDrawerVisible = false;
  rightTabs: ExgTabV2ComponentHeaderElement[] = [];
  leftTabs: ExgTabV2ComponentHeaderElement[] = [];
  init = true;
  workFlowMenu: any[] = [];
  renderRightTabs = true;
  openReportFolder: string[] = [];
  openAttachmentFolder: string[] = [];
  caseTable = {
    selectKey: 'auID',
    prefilter: 0,
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    uiFilterEnumGroup: [
      {
        enmName: 'Schadenart',
        enmField: 'aue_enmIdent_SchadenArt',
        enmTable: 'AuftragE_EIS',
        enmAlt: false,
        enmAltTT: true
      },
      {
        enmName: 'AuftragStatus',
        enmField: 'au_enmIdent_AuftragStatus',
        enmTable: 'Auftrag',
      },
      {
        enmName: 'AuftragTyp',
        enmField: 'au_enmIdent_AuftragTyp',
        enmTable: 'Auftrag',
      },
      // {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
    ],
    uiFilterSearchFields: [
      {table: 'Auftrag', tableField: 'auNr'},
      {table: 'Auftrag', tableField: 'auAuftraggeberShort', repColumn: 'au_oeID_Auftraggeber'},
      {table: 'All', tableField: 'auLCU', groupCaption: 'Auftrag'},
      {table: 'All', tableField: 'auLCD', groupCaption: 'Auftrag'},
      {table: 'All', tableField: 'auCKD', groupCaption: 'Auftrag'},
      {table: 'AuftragE_EIS', tableField: 'aueSchadenNr', groupCaption: 'Schaden'},
      {table: 'AuftragE_EIS', tableField: 'aueVersicherungsnehmer', groupCaption: 'Schaden'},
      {table: 'AuftragE_EIS', tableField: 'aueSchadenOrt', groupCaption: 'Schaden'},
    ],
    uiSortFieldGroup: [
      {fieldGroup: 'Auftrag', fieldTable: 'Auftrag', fieldName: 'auFrist'},
      {fieldGroup: 'Auftrag', fieldTable: 'All', fieldName: 'auLCD'},
      {fieldGroup: 'Auftrag', fieldTable: 'All', fieldName: 'auCRD'},
      {fieldGroup: 'Auftrag', fieldTable: 'All', fieldName: 'auCKD'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
    ],
    uiFilter: [] as any[],
    uiSort: [] as any[],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    uiFilterAktiv(filterType?: number): any[] {
      return this.uiFilter
        .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType))
        .filter((filters: any) =>
          ((filters.uiValue === true && filters.filterType === 1) ||
            (filters.filterCondition.value.length > 0 &&
              filters.filterType === 2))
        );
    },
    data: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 25,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    isLoading: true,

    ready: () => {
      if (!this.caseTable.data || this.caseTable.data.length === 0) {
        this.caseTable.state = 2;
        this.VCcaseTable.selectedRow = -1;
      } else {
        this.caseTable.state = 0;
        this.VCcaseTable.selectedRow = 0;
      }
      this.init = false;
    },
    selectionChanged: (index: number) => {
      this.caseTable.selectedRow = this.caseTable.data[index];
      if (this.caseTable.selectedRow && this.rightDrawerVisible) {
        this.CaseSummary = this.dataSvc.Case.Summary.Get(
          this.caseTable.selectedRow.auID,
          undefined,
          {Events: this.Events}
        );
      }
    },
    pageChanged: (page: number) => {
      if (this.caseTable.MetaInfo.dataPaging !== undefined) {
        this.caseTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.caseTable.loadData();
    },
    search: (value: string) => {
      this.caseTable.searchValue = value;
      this.caseTable.pageChanged(1);
    },
    loadData: () => {
      const SELF = this;
      SELF.caseTable.state = 1;
      SELF.caseTable.isLoading = true;
      SELF.renderRightTabs = true;
      SELF.excRest
        .sget(
          SELF.excRest.computeUrl('CaseR_List', {
            filter: this.caseTable.prefilter,
            fts: this.caseTable?.searchValue,
          }),
          'caseListState',
          {MetaInfo: SELF.caseTable.MetaInfo}
        )
        .subscribe((response) => {
          if (response.success && response.data) {
            SELF.caseTable.data = response.data;
            SELF.caseTable.paging = response.paging;
          } else {
            SELF.caseTable.data = [];
            SELF.caseTable.paging = {
              pagingPage: 0,
              pagingEndRow: 0,
              pagingPageSize: 25,
              pagingTotalPages: 0,
              pagingTotalRows: 0,
              pagingStartRow: 0,
            };
          }
          SELF.caseTable.ready();
          SELF.caseTable.isLoading = false;
        });
    },
  };
  //#region CaseSummary
  CaseSummary: ICaseSummaryData | any = this.dataSvc.Case.Summary.Get();
  config = {
    leistungList: {
      selectKey: 'leID',
      state: 1,
      searchValue: '',
      selectedRow: undefined as any,
      isLoading: false
    },
    receiptList: {
      treeControl: new NestedTreeControl<any>(node => node.receipts),
      selectKey: 'rcptID',
      state: 1,
      searchValue: '',
      selectedRow: undefined as any,
      uiFilterEnumGroup: [
        {enmName: 'ReceiptStatus', enmField: 'rcpt_enmIdent_ReceiptStatus', enmTable: 'Receipt'},
        {enmName: 'ReceiptTyp', enmField: 'rcpt_enmIdent_ReceiptType', enmTable: 'Receipt'},
        {
          enmName: 'Schadenart', enmField: 'aue_enmIdent_SchadenArt', enmTable: 'AuftragE_EIS', enmAlt: false,
          enmAltTT: true
        },
        {enmName: 'VorgangStatus', enmField: 'vorg_enmIdent_VorgangStatus', enmTable: 'Vorgang'},
        {enmName: 'VorgangTyp', enmField: 'vorg_enmIdent_VorgangTyp', enmTable: 'Vorgang'},
        {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
      ],
      uiFilterSearchFields: [
        {tableField: 'vorgNr', table: 'Vorgang'},
        {tableField: 'Bearbeiter', table: 'Vorgang'},
        {tableField: 'Bearbeiter_Handy', table: 'Vorgang'},
        {tableField: 'vorgLCU', table: 'All', groupCaption: 'Vorgang'},
        {tableField: 'vorgLCD', table: 'All', groupCaption: 'Vorgang'},
        {groupCaption: 'Vorgang', table: 'All', tableField: 'vorgCKD'},
        {table: 'Vorgang', tableField: 'vorgFrist'},
        {tableField: 'aueSchadenNr', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'aueVersicherungsnehmer', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'aueSchadenOrt', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'auAuftraggeberShort', table: 'Auftrag', repColumn: 'au_oeID_Auftraggeber'},
        {tableField: 'auAnsprechpartner', table: 'Auftrag'},
      ],
      uiSortFieldGroup: [
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD'},
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD'},
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD'},
        {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
      ],
      uiFilter: [] as any [],
      uiSort: [] as any [],
      uiSortAktiv(): any[] {
        return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
      },
      uiFilterAktiv(filterType?: number): any[] {
        return this.uiFilter
          .filter((filters: any) => filters.applied)
          .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType));
      },
      hasChild: (_: number, node: any): boolean => {
        return !!node.receipts && node.receipts.length > 0;
      },
      paging: {
        pagingPage: 0,
        pagingEndRow: 0,
        pagingPageSize: 25,
        pagingTotalPages: 0,
        pagingTotalRows: 0,
        pagingStartRow: 0
      },
      isLoading: true,
      selectionChanged: (index: number) => {
        this.config.receiptList.selectedRow = this.CaseSummary.receiptList.data[index];
      },
      pageChanged: (page: number) => {
        if (this.CaseSummary?.receiptList?.MetaInfo.dataPaging !== undefined) {
          this.CaseSummary.receiptList.MetaInfo.dataPaging.pageNo = page;
        }
        this.config.receiptList.loadData();
      },
      search(value: string): void {
        this.searchValue = value;
        this.loadData();
      },
      ready: () => {
        if (this.CaseSummary.receiptList.data.length === 0) {
          this.config.receiptList.state = 2;
          // this.VCreceiptList.selectedRow = -1;
        } else {
          this.config.receiptList.state = 0;
          // this.VCreceiptList.selectedRow = 0;
        }
        this.config.receiptList.isLoading = false;
      },
      loadData: (incomingData?: any, incomingPaging?: any) => {
        const SELF = this;
        if (!(incomingData && incomingPaging)) {
          SELF.config.receiptList.state = 1;
          SELF.config.receiptList.isLoading = true;
          SELF.excRest
            .get(
              SELF.excRest.computeUrl('ReceiptR_List', {
                fts: this.config.receiptList?.searchValue,
                auID: this.caseTable.selectedRow[this.caseTable.selectKey]
              }), {MetaInfo: SELF.CaseSummary.receiptList.MetaInfo})
            .subscribe(
              (data: any) => {
                if (data.success) {
                  SELF.CaseSummary.receiptList.loadData(data.data);
                }
                SELF.config.receiptList.ready();
              }
            );
        } else {
          SELF.CaseSummary.receiptList.loadData(incomingData);
        }
      },
      deleteReceipt: (event: any, rcptID: any, rcptUPT: any, rcptState: number) => {
        const SELF = this;

        event.preventDefault();
        event.stopPropagation();


        if (rcptState <= 2 || this.excSecurity.isFeatured('RECEIPTDELETE')) {
          SELF.modal.showSimple(
            this.getRessource('DeleteReceipt.Title'),
            this.getRessource('DeleteReceipt.Message'),
            true,
            true,
            this.getGlobal('Delete'),
            this.getGlobal('Cancel')
          ).subscribe((rtVal: boolean) => {
            if (rtVal) {
              SELF.config.receiptList.state = 1;
              SELF.config.receiptList.isLoading = true;
              SELF.excRest
                .delete(SELF.excRest.computeUrl('ReceiptD', {rcptID}), {rcptUPT}, {})
                .subscribe((ret: any) => {
                  if (ret) {
                    this.modal
                      .showToast(
                        ret.success
                          ? `${this.getGlobal('Success')} ${this.getGlobal('Delete')}`
                          : this.getGlobal('Cancel')
                        , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                        , ret.success ? 'fal fa-trash-can-check' : 'fal fa-times-circle');

                    this.Events.Receipt?.List?.Deleted?.emit();
                  }
                });
            }
          });
        }
      }
    },
    taskList: {
      selectKey: 'vorgID',
      state: 1,
      searchValue: '',
      selectedRow: undefined as any,
      uiFilterEnumGroup: [
        {enmName: 'ReceiptStatus', enmField: 'rcpt_enmIdent_ReceiptStatus', enmTable: 'Receipt'},
        {enmName: 'ReceiptTyp', enmField: 'rcpt_enmIdent_ReceiptType', enmTable: 'Receipt'},
        {enmName: 'Schadenart', enmField: 'aue_enmIdent_SchadenArt', enmTable: 'AuftragE_EIS', enmAlt: false},
        {enmName: 'VorgangStatus', enmField: 'vorg_enmIdent_VorgangStatus', enmTable: 'Vorgang'},
        {enmName: 'VorgangTyp', enmField: 'vorg_enmIdent_VorgangTyp', enmTable: 'Vorgang'},
        {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
      ],
      uiFilterSearchFields: [
        {tableField: 'vorgNr', table: 'Vorgang'},
        {tableField: 'Bearbeiter', table: 'Vorgang'},
        {tableField: 'Bearbeiter_Handy', table: 'Vorgang'},
        {tableField: 'vorgLCU', table: 'All', groupCaption: 'Vorgang'},
        {tableField: 'vorgLCD', table: 'All', groupCaption: 'Vorgang'},
        {groupCaption: 'Vorgang', table: 'All', tableField: 'vorgCKD'},
        {table: 'Vorgang', tableField: 'vorgFrist'},
        {tableField: 'aueSchadenNr', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'aueVersicherungsnehmer', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'aueSchadenOrt', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'auAuftraggeberShort', table: 'Auftrag', repColumn: 'au_oeID_Auftraggeber'},
        {tableField: 'auAnsprechpartner', table: 'Auftrag'},
      ],
      uiSortFieldGroup: [
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD'},
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD'},
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD'},
        {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
      ],
      uiFilter: [] as any [],
      uiSort: [] as any [],
      uiSortAktiv(): any[] {
        return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
      },
      uiFilterAktiv(filterType?: number): any[] {
        return this.uiFilter
          .filter((filters: any) => filters.applied)
          .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType));
      },
      paging: {
        pagingPage: 0,
        pagingEndRow: 0,
        pagingPageSize: 25,
        pagingTotalPages: 0,
        pagingTotalRows: 0,
        pagingStartRow: 0
      },
      isLoading: true,
      selectionChanged: (index: number) => {
        this.config.taskList.selectedRow = this.CaseSummary.taskList.data[index];
      },
      pageChanged: (page: number) => {
        if (this.CaseSummary?.taskDetails?.MetaInfo.dataPaging !== undefined) {
          this.CaseSummary.taskDetails.MetaInfo.dataPaging.pageNo = page;
        }
        this.config.taskList.loadData();
      },
      search(value: string): void {
        this.searchValue = value;
        this.loadData();
      },
      ready: () => {
        if (!this.CaseSummary?.taskList.data || this.CaseSummary?.taskList?.isEmpty) {
          this.config.taskList.state = 2;
          this.VCtaskList.selectedRow = -1;
        } else {
          this.config.taskList.state = 0;
          this.VCtaskList.selectedRow = 0;
        }
      },
      loadData: (incomingData?: any, incomingPaging?: any) => {
        const SELF = this;
        if (!(incomingData && incomingPaging)) {
          SELF.config.taskList.state = 1;
          SELF.config.taskList.isLoading = true;
          SELF.excRest
            .get(
              SELF.excRest.computeUrl('TaskR_List', {
                fts: this.config.taskList?.searchValue,
                vorgID: this.caseTable.selectedRow[this.caseTable.selectKey]
              }), {MetaInfo: SELF.CaseSummary.taskDetails.MetaInfo})
            .subscribe(
              (data: any) => {
                if (data.success) {
                  SELF.CaseSummary.taskDetails.loadData(data.data, data.paging);
                }
                SELF.config.taskList.isLoading = false;
                SELF.config.taskList.ready();
              }
            );
        } else {
          SELF.CaseSummary.taskDetails.loadData(incomingData, incomingPaging);
        }
      },
      selectedObjects: [] as any[],

      rowChange: (index: number) => {
        if (!this.config.taskList.selectedObjects.find((sOrt: any) => sOrt === this.CaseSummary?.taskList?.data[index])) {
          this.config.taskList.selectedObjects = [];
          this.config.taskList.selectedObjects.push(this.CaseSummary?.taskList?.data[index]);
        } else {
          this.VCtaskList.selectedRow = -1;
          this.config.taskList.selectedObjects = [];
        }
      },
      itemSelect: (index: number) => {
        if (this.config.taskList.selectedObjects.find((sOrt: any) => sOrt === this.CaseSummary?.taskList?.data[index])) {
          this.config.taskList.selectedObjects =
            this.config.taskList.selectedObjects.filter((sOrt: any) => sOrt !== this.CaseSummary?.taskList?.data[index]);
        } else {
          this.config.taskList.selectedObjects.push(this.CaseSummary?.taskList?.data[index]);
        }
      },
    },
    flowTable: {
      state: 1,
      ready: () => {
        if (!this.CaseSummary?.flowTable.data || this.CaseSummary?.flowTable.data.length === 0) {
          this.config.flowTable.state = 2;
        } else {
          this.config.flowTable.state = 0;
        }
      },
    },
    attachmentJagTable: {
      state: 1,
      ready: () => {
        if (!this.CaseSummary?.attachmentJagTable.data || this.CaseSummary?.attachmentJagTable?.isEmpty) {
          this.config.attachmentJagTable.state = 2;
        } else {
          this.config.attachmentJagTable.state = 0;
        }
      },

      hasChild: (_: number, node: any): boolean => {
        return !!node.documents && node.documents.length > 0;
      },

      treeControl: new NestedTreeControl<any>(node => node.documents),
    },
    gdvReceiptList: {
      state: 1,
      ready: (): void => {
        if (!this.CaseSummary?.gdvReceiptList?.data || this.CaseSummary?.gdvReceiptList?.data.length === 0) {
          this.config.gdvReceiptList.state = 2;
        } else {
          this.config.gdvReceiptList.state = 0;
        }
      }
    },
    getOEByID: (ID: string): any => {
      return ExcCoreModule.Array.GetObject(this.CaseSummary?.oeList?.data, 'oeID', ID);
    },
    treeControl: new NestedTreeControl<any>(node => node.documents),
    newMessage: (): void => {
      this.appSvc.Message.NewForCase.OpenTab({objID: this.CaseSummary?.ID}, {Events: this.Events});
    },

    newDefaultMessage: (dmsgID: any): void => {
      this.appSvc.Message.NewForCase.OpenTab({objID: this.CaseSummary?.ID, dmsgID: dmsgID}, {Events: this.Events});
    },

    newServiceRecord: (): void => {
      this.appSvc.Leistungserfassung.New(
        {fkID: this.CaseSummary?.ID, fkType: 'Auftrag'},
        {Events: this.Events}
      );
    },

    newReport: (): void => {
      this.appSvc.Report.New(this.CaseSummary?.ID, {Events: this.Events});
    },

    newNote: (): void => {
      this.appSvc.Note.OpenModal({ntz_objID: this.CaseSummary?.ID}, {Events: this.Events});
    },

    openLink: (row: any): void => {
      this.appSvc.LinkedObject.OpenLink(row, {Events: this.Events});
    },

    showHistory: (): void => {
      this.appSvc.History.OpenModal(this.CaseSummary?.historyTable?.data);
    },
    showAttachmentUploadModal: (): void => {
      this.appSvc.Document.Upload.OpenModal({dok_objID: this.CaseSummary?.ID}, {Events: this.Events});
    },

    showAttachmentUpdateModal: (dokID: string): void => {
      this.appSvc.Document.Update.OpenModal({dokID: dokID}, {Events: this.Events});
    },

    showAttachmentPreview: (dokID?: string): void => {
      this.appSvc.Document.Preview.OpenModal({objID: this.CaseSummary?.ID, attID: dokID}, {Events: this.Events});
    },

    onDblClickTaskWorkspace: (index: number): void => {
      if (this.config.taskList.selectedRow[this.config.taskList.selectKey]) {
        this.appSvc.Task.Workspace.OpenTabV2(
          this.config.taskList.selectedRow[this.config.taskList.selectKey]
        );
      }
    },

    onClickOpenTaskCheckview: (task: any): void => {
      if (this.excSecurity.isFeatured('TASKREAD')) {
        this.appSvc.Task.Workspace.OpenTabV2(task.vorgID);
      }
    },

    openEditMode: (): void => {
      if (!this.excSecurity.isFeatured('CASEEDIT')) {
        this.modal.showToast('Sie sind nicht berechtigt den Auftrag zu editieren!', 'md-toast', 'fas fa-exclamation');
      } else {
        this.editMode = true;
        this.CaseSummary?.LoadSummary();
      }
    },

    cloneCase: (): void => {
      const sourceCase = this.CaseSummary?.caseDetails?.data;
      const sourceAuID = sourceCase?.auID;
      const sourceAuNr = sourceCase?.auNr;
      if (!sourceAuID || !sourceAuNr) {
        this.modal.showToast(
          'Der Auftrag konnte nicht ermittelt werden.',
          'md-toast bg-red',
          'fas fa-exclamation-circle'
        );
        return;
      }
      if (!this.excSecurity.isFeatured('CASECLONE')) {
        this.modal.showToast(
          'Sie sind nicht berechtigt, einen Auftrag zu klonen.',
          'md-toast bg-red',
          'fas fa-exclamation-circle'
        );
        return;
      }
      this.modal.showSimple(
        'Auftrag klonen',
        `Soll der Auftrag ${sourceAuNr} wirklich geklont werden?`,
        true,
        true,
        'Klonen',
        this.getGlobal('Cancel')
      ).subscribe((confirmed: boolean) => {
        if (!confirmed) {
          return;
        }
        const data = {
          CopyFromAuNr: sourceAuNr
        };
        this.excRest
          .post(
            this.excRest.computeUrl('CaseCloneC'),
            data
          )
          .subscribe((response: any) => {
            if (response?.success) {
              const result = response.data?.[sourceAuID];
              const targetAuID = result?.TargetAuID;
              const targetAuNr = result?.TargetAuNr;
              this.modal.showToast(
                targetAuNr
                  ? `Der Auftrag wurde erfolgreich als ${targetAuNr} geklont.`
                  : 'Der Auftrag wurde erfolgreich geklont.',
                'md-toast bg-green',
                'fas fa-check-circle'
              );
              if (targetAuID) {
                this.appSvc.Case.Workspace.OpenTabV2(
                  targetAuID,
                  {Events: this.Events}
                );
              } else {
                this.modal.showToast(
                  'Der Auftrag wurde geklont, konnte aber nicht automatisch geöffnet werden.',
                  'md-toast bg-red',
                  'fas fa-exclamation-circle'
                );
              }
            } else {
              this.modal.showToast(
                'Der Auftrag konnte nicht geklont werden.',
                'md-toast bg-red',
                'fas fa-exclamation-circle'
              );
            }
          });
      });
    },

    saveEditMode: (): void => {
      if (!this.excSecurity.isFeatured('CASEEDIT')) {
        this.modal.showToast('Sie sind nicht berechtigt den Auftrag zu editieren!', 'md-toast', 'fas fa-exclamation');
      } else {
        this.editMode = false;
        if (this.uiModel.aueLeistungsgegenstand === '|0|') {
          this.uiModel.aueLeistungsgegenstand = null;
        }
        this.uiModel.aueVersicherungSumme = this.uiModel.aueWert1914 * this.CaseSummary?.wert1914Faktor?.data;

        this.caseDataSvc.Case.Update(this.uiModel)
          .subscribe((response: any) => {
            this.CaseSummary?.LoadSummary(response);
          });
      }
    },

    cancelEditMode: (): void => {
      this.editMode = false;
      this.CaseSummary?.LoadSummary();
    },

  };

  dataSummmaryLoaded = new BehaviorSubject(false);

  aueLeistungsgegenstandEnmList: any[] = this.appSvc.helperObj.clone(this.enumSvc.getEnumerationList('Leistungsgegenstand'));
  showSchadenartUrsache = false;

  constructor(public excRest: ExcRestService,
              public modal: ExgModalService,
              public excSecurity: ExcSecurityService,
              public enumSvc: EnumerationService,
              public appSvc: ApplicationService,
              private dataSvc: DataService,
              private caseDataSvc: CaseDataService,
              private renderer: Renderer2) {
    super();
    this.registerEvents();
    this.initialize();
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      if (this.tabinstance.Active) {
        this.CaseSummary?.LoadSummary();
      }
    });
    ExcCoreModule.Services().StrgI.subscribe(() => {
      if (this.tabinstance.Active) {
        this.rightDrawerVisible = !this.rightDrawerVisible;
      }
    });
    this.dataSummmaryLoaded.subscribe(async (temp) => {
      if (temp) {
        await new Promise(f => setTimeout(f, 250));
      }
    });
    this.Events.Leistungserfassung?.New?.Save?.subscribe((evt: ExgEventArgs) => {
      this.CaseSummary?.LoadSummary();
    });
    this.Events.Message?.NewForTask?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.CaseSummary?.LoadSummary();
    });
    this.Events.NoteDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.CaseSummary?.LoadSummary();
    });
    this.Events.Document?.UploadDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.CaseSummary?.LoadSummary();
    });
    this.Events.Document?.UpdateDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.CaseSummary?.LoadSummary();
    });
    this.Events.Schedule?.UpdateSchedule?.Closed?.subscribe(() => {
      this.init = true;
      this.CaseSummary?.LoadSummary();
    });
    this.Events.Schedule?.CreateSchedule?.Closed?.subscribe(() => {
      this.init = true;
      this.CaseSummary?.LoadSummary();
    });
    this.Events.Case?.NewTask.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      this.init = false;
      this.CaseSummary?.LoadSummary();
    });
    this.Events.Receipt?.List?.Deleted?.subscribe((evt: ExgEventArgs) => {
      this.CaseSummary?.LoadSummary();
    });
    this.Events.Case?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.config.receiptList.ready();
        this.config.flowTable.ready();
        this.config.attachmentJagTable.ready();
        this.config.gdvReceiptList.ready();
        this.buildRightTabs();
        this.renderRightTabs = false;
        // this.config.taskDetails.ready();
        this.tabinstance.Label = this.CaseSummary?.caseDetails?.data?.auNr;
        this.init = false;
        this.dataSummmaryLoaded.next(true);
        this.getCaseDetails();
        // this.uiModel.processingNumber = this.CaseSummary?.caseDetails?.data?.auMdtOKZ
      }
    });
    this.Events.DialogueQuestion.DataLoaded.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        const x = evt.data.find((e: any) => {
          return e.dfPflichtfeld && (!e.deValue || e.deValue === '');
        });
        if (this.init && x) {
          this.openDialogueQuestions();
        }
      }

    });
    this.Events.Message.Reader.LinkChanged?.subscribe((evt: ExgEventArgs) => {
      this.CaseSummary?.LoadSummary();
    });
  }

  initialize(): void {
    const SELF = this;
    this.leftTabs = [
      {
        get caption(): string {
          return SELF.getResource('Tabs.Details.Tab1');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Details.Tab1Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Details.Tab2');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Details.Tab2Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Details.Tab3');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Details.Tab3Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Details.Tab4');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Details.Tab4Icon');
        }
      },
      // {
      //   get caption(): string {
      //     return SELF.getResource('Tabs.Details.Tab5');
      //   },
      //   get icon_class(): string {
      //     return SELF.getResource('Tabs.Details.Tab5Icon');
      //   }
      // },
      // {
      //   get caption(): string {
      //     return SELF.getResource('Tabs.Details.Tab6');
      //   },
      //   get icon_class(): string {
      //     return SELF.getResource('Tabs.Details.Tab6Icon');
      //   }
      // },
    ];
    this.rightTabs = [
      {
        get caption(): string {
          return SELF.getResource('Tabs.Progress.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Progress.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Attachments.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Attachments.Icon');
        }
      },
      {
        get caption(): string {
          return 'Bericht';
        },
        get icon_class(): string {
          return 'fal fa-clipboard-list';
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RQUESTVREAD')
            && !SELF.excSecurity.isFeatured('RPHOTOREAD')
            && !SELF.excSecurity.isFeatured('RCALCVREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Receipts.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Receipts.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RECEIPTREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.ServiceRecords.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.ServiceRecords.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Tasks.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Tasks.Icon');
        }
      },
    ];
    this.workFlowMenu = [
      {
        // Ablaufplan erstellen
        security: 'VORGAPINIT',
        get caption(): string {
          return SELF.getResource('Workflow.TaskCreateAP');
        },
        get visible(): boolean {
          return ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
            && false;
        },
        click(): void {
        }
      },
      {
        // Dokumentenmanagement
        security: 'DOKMGMT',
        get caption(): string {
          return SELF.getResource('Workflow.DocumentManagement');
        },
        get visible(): boolean {
          return ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
            && false;
        },
        click(): void {
        }
      },
      {
        // An Exakt:App senden (Motionscloud)
        security: 'DOKMGMT',
        get caption(): string {
          return SELF.getResource('Workflow.SendToExaktApp');
        },
        get visible(): boolean {
          return ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
            && false;
        },
        click(): void {
        }
      },
      {
        // Fragen beantworten
        security: '*',
        get caption(): string {
          return SELF.getResource('Workflow.AnswerQuestions');
        },
        get visible(): boolean {
          return (!SELF.CaseSummary || SELF.CaseSummary?.dialogueQuestions?.data?.length > 0);
        },
        click(): void {
          SELF.openDialogueQuestions();
        }
      },
      {
        // QS-Regulierungsvereinbarung/Kurzbericht abschließen
        security: 'DOKMGMT',
        get caption(): string {
          return SELF.getResource('Workflow.QSFinish');
        },
        get visible(): boolean {
          return ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
            && SELF.CaseSummary?.caseDetails?.data?.vorg_enmIdent_VorgangTyp === 24;
        },
        click(): void {
        }
      },
      {
        // Auftrag geprüft markieren
        security: 'CASECHECK',
        get caption(): string {
          return SELF.getResource('Workflow.CaseCheck');
        },
        get visible(): boolean {
          return ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
        },
        click(): void {
          SELF.setCaseChecked();
        }
      },
      {
        // An mich disponieren
        security: 'CASEDISPO',
        get caption(): string {
          return SELF.getResource('Workflow.AssignToMe');
        },
        get visible(): boolean {
          return ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
            && false;
        },
        click(): void {
        }
      },
      {
        // Status manuell ändern
        security: 'CASESTATCHANGE',
        get caption(): string {
          return 'Status manuell ändern';
        },
        get visible(): boolean {
          if (this._visible === undefined) {
            this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
          }
          return this._visible;
        },
        click: (): void => {
          this.openCaseStateModal();
        },
      }
    ];
  }
  buildRightTabs(): void {
    const SELF = this;
    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getResource('Tabs.Progress.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Progress.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Attachments.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Attachments.Icon');
        }
      },
    ];

    if (SELF.CaseSummary?.caseDetails?.data && SELF.CaseSummary?.caseDetails?.data?.showGDVActions) {
      SELF.rightTabs.push(
        {
          get caption(): string {
            return SELF.getResource('Tabs.GDVReceipt.HeaderText');
          },
          get icon_class(): string {
            return SELF.getResource('Tabs.GDVReceipt.Icon');
          }
        }
      );
    }

    SELF.rightTabs.push(
      {
        get caption(): string {
          return 'Bericht';
        },
        get icon_class(): string {
          return 'fal fa-clipboard-list';
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RQUESTVREAD')
            && !SELF.excSecurity.isFeatured('RPHOTOREAD')
            && !SELF.excSecurity.isFeatured('RCALCVREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Receipts.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Receipts.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RECEIPTREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.ServiceRecords.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.ServiceRecords.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Tasks.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Tasks.Icon');
        }
      }
    );

    if (SELF.VCrightTabControl) {
      setTimeout(() => {
        this.VCrightTabControl._selectedtab = 0;
      }, 0);
    }
  }
  /*{
   // Editieren
   security: '*',
   get caption(): string {
     return SELF.getResource('Workflow.EditFields');
   },
   get visible(): boolean {
     return ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
   },
   click(): void {
     SELF.editMode = true;
   }
 }*/

/* Lifecycle Hooks*/
  ngOnInit(): void {
    this.CaseSummary = this.dataSvc.Case.Summary.Get(this.Data, undefined, {Events: this.Events});
  }

  getCaseDetails(): void {
    this.uiModel.auID = this.CaseSummary?.caseDetails?.data?.auID;
    this.uiModel.au_enmIdent_AuftragTyp = this.CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragTyp;
    this.uiModel.auMdtOKZ = this.CaseSummary?.caseDetails?.data?.auMdtOKZ;
    this.uiModel.auOKZ = this.CaseSummary?.caseDetails?.data?.auOKZ;
    this.uiModel.aue_enmIdent_Versicherungsart = this.CaseSummary?.caseDetails?.data?.aue_enmIdent_Versicherungsart;
    this.uiModel.aueVersicherungSumme = this.CaseSummary?.caseDetails?.data?.aueVersicherungSumme;
    this.uiModel.aueWert1914 = this.CaseSummary?.caseDetails?.data?.aueWert1914;
    this.uiModel.aueSelbstbehalt = this.CaseSummary?.caseDetails?.data?.aueSelbstbehalt;
    this.uiModel.aueHinweiseEntschaedigungsgrenze = this.CaseSummary?.caseDetails?.data?.aueHinweiseEntschaedigungsgrenze;
    this.uiModel.aueReserveVU = this.CaseSummary?.caseDetails?.data?.aueReserveVU;
    this.uiModel.aueReserve = this.CaseSummary?.caseDetails?.data?.aueReserve;
    this.uiModel.aueSchadensumme = this.CaseSummary?.caseDetails?.data?.aueSchadensumme;
    this.uiModel.aueRegulierungsumme = this.CaseSummary?.caseDetails?.data?.aueRegulierungsumme;
    this.uiModel.aueEinsparbetrag = this.CaseSummary?.caseDetails?.data?.aueEinsparbetrag;
    if (this.CaseSummary?.caseDetails?.data?.aueLeistungsgegenstand) {
      this.uiModel.aueLeistungsgegenstand = this.CaseSummary?.caseDetails?.data?.aueLeistungsgegenstand;
      this.extractLeistungsgegenstandOnReload();
    }
    this.uiModel.aueRegressmoeglichkeit_enmIdent = this.CaseSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmIdent;
    this.uiModel.aueAuftragsdatum = this.CaseSummary?.caseDetails?.data?.aueAuftragsdatum;
    this.uiModel.aueOrtsterminPlan = this.CaseSummary?.caseDetails?.data?.aueOrtsterminPlan;
    this.uiModel.aueKontaktaufnahme = this.CaseSummary?.caseDetails?.data?.aueKontaktaufnahme;
    this.uiModel.aueOrtstermin = this.CaseSummary?.caseDetails?.data?.aueOrtstermin;
    this.uiModel.aueOrtstermin2 = this.CaseSummary?.caseDetails?.data?.aueOrtstermin2;
    this.uiModel.aueWeitereOrtstermine = this.CaseSummary?.caseDetails?.data?.aueWeitereOrtstermine;
    this.uiModel.aueFristverlaengerungBis = this.CaseSummary?.caseDetails?.data?.aueFristverlaengerungBis;
    this.uiModel.aueReklamation_enmIdent = this.CaseSummary?.caseDetails?.data?.aueReklamation_enmIdent;
    this.uiModel.aueZwischenberichtDatum = this.CaseSummary?.caseDetails?.data?.aueZwischenberichtDatum;
    this.uiModel.aueAbschlussdatum = this.CaseSummary?.caseDetails?.data?.aueAbschlussdatum;
    this.uiModel.aueAbrechnungshinweis_enmIdent = this.CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent;
    this.uiModel.aueAbrechnungshinweisSub1_enmIdent = this.CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisSub1_enmIdent;
    this.uiModel.aueAbrechnungshinweisSub1_enmName = this.CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisSub1_enmName;
    this.uiModel.aueAbrechnungshinweisDatum = this.CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisDatum;
    this.uiModel.aueSchadenNr = this.CaseSummary?.caseDetails?.data?.aueSchadenNr;
    this.uiModel.aue_adrID_SchadenOrt = this.CaseSummary?.caseDetails?.data?.aue_adrID_SchadenOrt;
    this.uiSchadenort = this.appSvc.helperObj.clone(this.CaseSummary?.Schadenort?.data);
    this.uiModel.aueSchadenDatum = this.CaseSummary?.caseDetails?.data?.aueSchadenDatum;
    this.uiModel.aueSchadenmeldungVU = this.CaseSummary?.caseDetails?.data?.aueSchadenmeldungVU;
    this.uiModel.aue_enmIdent_SchadenArt = this.CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt;
    this.uiModel.aue_enmIdent_SchadenUrsache = this.CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenUrsache;
    this.uiModel.aue_enmName_SchadenUrsache = this.CaseSummary?.caseDetails?.data?.aue_enmName_SchadenUrsache;
    this.uiModel.auBeschreibung = this.CaseSummary?.caseDetails?.data?.auBeschreibung;
    this.showSchadenartUrsache = true;

    this.uiModel = this.appSvc.helperObj.clone(this.uiModel);
  }

  //#region TaskWorkspace
  updateSchedule(index: number): void {
    if (this.excSecurity.isFeatured('SCHEDULEEDIT')) {
      this.appSvc.Schedule.Update.OpenModal({
        worklistData: this.CaseSummary?.workList?.data,
        worklistItem: this.CaseSummary?.workList?.data[index]
      }, {Events: this.Events});
    }
  }

  updateScheduleWithRow(row: any): void {
    if (this.excSecurity.isFeatured('SCHEDULEEDIT') && row) {
      this.appSvc.Schedule.Update.OpenModal({
        worklistData: this.CaseSummary?.workList?.data, worklistItem: row
      }, {Events: this.Events});
    }
  }

  openNewAdrModal(
    adrToChange: string,
    parentOEID: string = '00000000-0000-0000-0000-000000000000'
  ): void {
    this.modal.show(
      'ModalLocationCreateComponent',
      {new: true, adr_enmIdent_AdresseTyp: 5},
      true
    ).subscribe(data => {
      if (data) {
        const url = this.excRest.computeUrl(
          'OeAdresseC_Schadenort',
          {oeID: parentOEID}
        );

        this.excRest.post(url, data).subscribe((ret: any) => {
          if (ret?.data?.Schadenort?.adrID) {
            this.uiModel[adrToChange] = ret.data.Schadenort.adrID;
            this.uiSchadenort = ret.data.Schadenort;
          }
        });
      }
    });
  }

  showObjectImageUpdateModal(): void {
    this.appSvc.Document.Preview.OpenModal({
      objID: this.CaseSummary?.ID,
      attID: this.CaseSummary?.caseDetails?.data?.aueObjektbild_dokID,
      CustomAction: {
        caption: this.getResource('caption'),
        click: (item: any) => {
          if (item) {
            const data = {aueObjektbild_dokID: item.dokID};
            this.excRest.put(this.excRest.computeUrl('CaseU_ObjectPic', {auID: this.CaseSummary?.caseDetails?.data.auID})
              , data).subscribe((response: any) => {
              if (response) {
                this.CaseSummary?.LoadSummary();
              }
            });
          }
        }
      },
      allowedMIME: ['image/*']
    }, {Events: this.Events});
  }

  openDialogueQuestions(): void {
    this.appSvc.DialogueQuestion.OpenModal(this.CaseSummary?.dialogueQuestions.data, {Events: this.Events});
  }

  isWorkflowActive(): boolean {
    return this.workFlowMenu.findIndex(e => e.visible) !== -1;
  }

  createSchedule(): void {
    this.appSvc.Schedule.Create.OpenModal(
      {worklistData: this.CaseSummary?.workList?.data, auID: this.CaseSummary?.ID}, {Events: this.Events});
  }

  createNewTask(): void {
    this.appSvc.Case.NewTask.OpenTab(
      {auID: this.CaseSummary?.ID},
      {Events: this.Events}
    );
  }

  setCaseChecked(): void {
    this.auCHK = 1;
    const data = {auCHK: this.auCHK};
    this.excRest.put(this.excRest.computeUrl('CaseU_Check',
      {auID: this.CaseSummary?.caseDetails?.data.auID}), data).subscribe((response: any) => {
      if (response.success) {
        this.CaseSummary?.LoadSummary();
        this.modal.showToast(this.getTranslation('CaseWorkspaceComponent.CaseCheck.Success'), 'md-toast', 'fas fa-check-circle');
      } else {
        this.modal.showToast(this.getTranslation('CaseWorkspaceComponent.CaseCheck.Fail'), 'md-toast', 'fas fa-exclamation');
      }
    });
  }

  changeEnum($event: { index: number; value: any }): void  {
    console.log($event);
    if ($event.value.enmName === this.CaseSummary?.caseDetails?.data?.au_enmName_AuftragTyp) {
      this.uiModel.au_enmIdent_AuftragTyp = $event.value.enmIdent;
    }

    if ($event.value.enmName === this.CaseSummary?.caseDetails?.data?.aue_enmName_Versicherungsart) {
      this.uiModel.aue_enmIdent_Versicherungsart = $event.value.enmIdent;
    }

    if ($event.value.enmName === 'Leistungsgegenstand') {
      this.uiModel.aueLeistungsgegenstand = '|' + $event.value.enmIdent.toString() + '|';
    }

    if ($event.value.enmName === this.CaseSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmName) {
      this.uiModel.aueRegressmoeglichkeit_enmIdent = $event.value.enmIdent;
    }

    if ($event.value.enmName === this.CaseSummary?.caseDetails?.data?.aueReklamation_enmName) {
      this.uiModel.aueReklamation_enmIdent = $event.value.enmIdent;
    }

    if ($event.value.enmName === this.CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName) {
      this.uiModel.aueAbrechnungshinweis_enmIdent = $event.value.enmIdent;
      this.uiModel.aueAbrechnungshinweisSub1_enmName = $event.value.enmSelector;
      this.uiModel.aueAbrechnungshinweisSub1_enmIdent = 0;
    }

    if ($event.value.enmName === this.uiModel.aueAbrechnungshinweisSub1_enmName) {
      this.uiModel.aueAbrechnungshinweisSub1_enmIdent = $event.value.enmIdent;
    }

    if ($event.value.enmName === this.CaseSummary?.caseDetails?.data?.aue_enmName_SchadenArt) {
      this.uiModel.aue_enmIdent_SchadenArt = $event.value.enmIdent;
      this.uiModel.aue_enmName_SchadenUrsache = $event.value.enmSelector;
      this.uiModel.aue_enmIdent_SchadenUrsache = 0;
    }

    if ($event.value.enmName === this.uiModel.aue_enmName_SchadenUrsache) {
      this.uiModel.aue_enmIdent_SchadenUrsache = $event.value.enmIdent;
    }

  }

  openCaseStateModal(): void {
    if (this.excSecurity.isFeatured('CASESTATCHANGE')) {
      const caseData = this.CaseSummary.caseDetails.data;
      const enumList = this.enumSvc.getEnumerationList('AuftragStatus');
      /**/
      if (caseData && enumList?.length > 0) {
        this.modal.show('ModalCaseStateChangeCommentComponent', {caseState: caseData.au_enmIdent_AuftragStatus, enums: enumList})
          .subscribe((modalResponse: any) => {
            if (modalResponse && caseData.au_enmIdent_AuftragStatus !== modalResponse.selectedStateEnmIdent){
              /*different State was selected*/
              if (caseData.au_enmIdent_AuftragStatus !== modalResponse.selectedStateEnmIdent) {
                this.caseDataSvc.Case.ManualStateChange(this.CaseSummary.caseDetails.data
                  , modalResponse.selectedStateEnmIdent
                  , modalResponse.stateChangeComment)
                  .subscribe(() => {
                    this.CaseSummary?.LoadSummary();
                    this.modal.showToast(
                      this.getRessource('StateChange.Success')
                      , 'md-toast', 'fas fa-check-circle');
                  });
              }
              /*no Response from Modal*/
            } else if (modalResponse && caseData.au_enmIdent_AuftragStatus === modalResponse.selectedStateEnmIdent) {
              this.modal.showToast(
                this.getGlobal('NoChanges')
                , 'md-toast', 'fas fa-exclamation');
            }
          });
      }
    }
  }

  createOE(OEtoChange: string
    ,      parentOEID: string = '00000000-0000-0000-0000-000000000000'
    ,      predefinedCRMRolle: number = 0
    ,      predefinedOETyp: number = 0
    ,      isCompany: boolean = false): void {
    const repTable = OEtoChange.startsWith('aue') ? 'AuftragE_EIS' : 'Auftrag';
    this.modal.show('ModalOeComponent', {
      new: true,
      showAssignButton: true,
      isCompany,
      oeIDparent: parentOEID,
      predefinedCrmRolle: predefinedCRMRolle,
      predefinedEnmIdentOETyp: predefinedOETyp
    }).subscribe((result: any) => {
      if (result?.OEDetails?.oeID) {
        this.updateOE(OEtoChange, {chosenOE: {oeID: result.OEDetails.oeID}}, repTable);
      }
    });
  }
  changeOE(OEtoChange: string
         , parentOEID: string = '00000000-0000-0000-0000-000000000000'
         , predefinedCRMRolle: number = 0
         , predfinedOETyp: number = 0): void {
    const repTable = OEtoChange.startsWith('aue') ? 'AuftragE_EIS' : 'Auftrag';
    const isWAnspr = OEtoChange.startsWith('aue_oeID_WAnspr');
    let chosenWAnspr = '';
    if (isWAnspr) {
      const whichWAnsprNr = OEtoChange.slice(-1);  /*Kann 1, 2, 3 oder 4 sein*/
      chosenWAnspr = 'aue_enmIdent_WAnsprPtnr' + whichWAnsprNr + 'Funktion';
    }
    this.openOEModal(predefinedCRMRolle, predfinedOETyp, parentOEID, isWAnspr, OEtoChange, repTable, chosenWAnspr);
  }

  private openOEModal( predefinedCRMRolle: number = 0
    ,                  predfinedOETyp: number = 0, parentOEID: string
    ,                  isWAnspr: boolean, OEtoChange: string, repTable: string, chosenWAnspr: string): void {
    this.modal.show('ModalChooseOEComponent'
      , {
        oe_CrmRolle: predefinedCRMRolle
        , oe_enmIdent_OETyp: predfinedOETyp
        , isWAnspr: isWAnspr
        , selectedWAnsprEnmIdent: this.CaseSummary?.caseDetails?.data?.[chosenWAnspr]
        , parentOEID: parentOEID
      }).subscribe((modalResponse: any) => {
      if (modalResponse) {
        this.handleOEModalResponse(OEtoChange, modalResponse, repTable);
      }
    });
  }

  private handleOEModalResponse(OEtoChange: string, modalResponse: any, repTable: string): void {
    const isWAnspr = OEtoChange.startsWith('aue_oeID_WAnspr');
    if (isWAnspr) {
      this.updateWAnsprOE(OEtoChange, modalResponse, repTable);
    }
    else {
      this.updateOE(OEtoChange, modalResponse, repTable);
    }
  }

  private updateOE(OEtoChange: string, modalResponse: any, repTable: string): void {
    const updatedOE = {
      [OEtoChange]: modalResponse.chosenOE.oeID,
      auUPT: this.CaseSummary?.caseDetails?.data?.auUPT
    };
    this.excRest.put(this.excRest.computeUrl('CaseU_SetOE',
        {auID: this.CaseSummary?.caseDetails?.data?.auID}),
      updatedOE)
      .subscribe((UpdateResponse: any) => {
        if (UpdateResponse.success) {
          this.CaseSummary?.LoadSummary();
          this.modal.showToast(
            this.getRessource('ChangeOE.Success'
              , {OEtoChange: this.enumSvc.getFieldCaption(repTable, OEtoChange)})
            , 'md-toast', 'fas fa-check-circle');
        } else {
          this.modal.showToast(
            this.getRessource('ChangeOE.Failure'
              , {OEtoChange: this.enumSvc.getFieldCaption(repTable, OEtoChange)})
            , 'md-toast', 'fas fa-check-circle');
        }
      });
  }

  deleteOE(OEtoDelete: string): void {
    const SELF = this;
    const repTable = OEtoDelete.startsWith('aue') ? 'AuftragE_EIS' : 'Auftrag';
    const isWAnspr = OEtoDelete.startsWith('aue_oeID_WAnspr');
    let uiName = '';
    if (isWAnspr) {
      const whichWAnsprNr = OEtoDelete.slice(-1);  /*Kann 1, 2, 3 oder 4 sein*/
      const chosenWAnspr = 'aue_enmIdent_WAnsprPtnr' + whichWAnsprNr + 'Funktion';
      uiName =  this.enumSvc.getEnumerationText('WAnsprPtnrFunktion',
        this.CaseSummary?.caseDetails?.data?.[chosenWAnspr]); }
    else {
      uiName = this.enumSvc.getFieldCaption(repTable, OEtoDelete);
    }
    this.modal.showSimple(
      this.getRessource('DeleteOE.Title', {OEtoDelete: uiName})
      , this.getRessource('DeleteOE.Question', {OEtoDelete: uiName})
      , true, true, this.getRessource('DeleteOE.Remove'), this.getGlobal('Cancel'))
      .subscribe((modalResponse: any) => {
        if (modalResponse) {
          const updatedOE = {
            [OEtoDelete]: '00000000-0000-0000-0000-000000000000',
            auUPT: this.CaseSummary?.caseDetails?.data?.auUPT
          };
          SELF.excRest.put(SELF.excRest.computeUrl('CaseU_SetOE',
              {auID: this.CaseSummary?.caseDetails?.data?.auID}),
            updatedOE)
            .subscribe((UpdateResponse: any) => {
              if (UpdateResponse.success) {
                this.CaseSummary?.LoadSummary();
                this.modal.showToast(
                  SELF.getRessource('DeleteOE.Success'
                    , {OEtoDelete: uiName})
                  , 'md-toast', 'fas fa-check-circle');
              } else {
                this.modal.showToast(
                  SELF.getRessource('DeleteOE.Failure'
                    , {OEtoDelete: uiName})
                  , 'md-toast', 'fas fa-check-circle');
              }
            });
        }
      });
  }

  private updateWAnsprOE(OEtoChange: string, modalResponse: any, repTable: string): void {
    const whichWAnsprNr = OEtoChange.slice(-1);  /*Kann 1, 2, 3 oder 4 sein*/
    const chosenWAnspr = 'aue_enmIdent_WAnsprPtnr' + whichWAnsprNr + 'Funktion';
    const updatedOE = {
      [OEtoChange]: modalResponse.chosenOE.oeID,
      [chosenWAnspr]: modalResponse.chosenWAnsprEnmIdent,
      auUPT: this.CaseSummary?.caseDetails?.data?.auUPT
    };
    this.excRest.put(this.excRest.computeUrl('CaseU_SetWAnsprOE',
        {auID: this.CaseSummary?.caseDetails?.data?.auID}),
      updatedOE)
      .subscribe((UpdateResponse: any) => {
        if (UpdateResponse.success) {
          this.CaseSummary?.LoadSummary();
          this.modal.showToast(
            this.getRessource('ChangeOE.Success'
              , {OEtoChange: this.enumSvc.getEnumerationText('WAnsprPtnrFunktion', modalResponse.chosenWAnsprEnmIdent) })
            , 'md-toast', 'fas fa-check-circle');
        } else {
          this.modal.showToast(
            this.getRessource('ChangeOE.Failure'
              , {OEtoChange: this.enumSvc.getEnumerationText('WAnsprPtnrFunktion', modalResponse.chosenWAnsprEnmIdent)})
            , 'md-toast', 'fas fa-check-circle');
        }
      });
  }

  computeAueLeistungsgegenstand(): void {
    if (this.aueLeistungsgegenstandEnmList?.length > 0) {
      const chosenEnumsArray: any[] = [];
      this.aueLeistungsgegenstandEnmList.forEach((item: any) => {
        if (item?.enmValue) {
          chosenEnumsArray.push(item.enmIdent);
        }
      });

      if (chosenEnumsArray.length > 0) {
        let enmIdentsString: string = chosenEnumsArray.join('||'); // Verbinde die IDs mit "||" als Trennzeichen
        // Füge | am Anfang und Ende hinzu
        enmIdentsString = `|${enmIdentsString}|`;
        this.uiModel.aueLeistungsgegenstand  = enmIdentsString;
      }
      else {
        this.uiModel.aueLeistungsgegenstand = '';
      }
    }
  }

  private extractLeistungsgegenstandOnReload(): void {
    if (this.uiModel.aueLeistungsgegenstand) {
      // Extrahiere die durch || getrennten enmIdent-Werte aus der Zeichenkette
      const enmIdentsString: string = this.uiModel.aueLeistungsgegenstand;
      const enmIdentsArray: string[] = enmIdentsString
        .slice(1, -1) // Entferne die führenden und endenden "|"
        .split('||') // Splitte anhand von "||"
        .filter((ident) => ident); // Entferne eventuell leere Einträge

      if (this.aueLeistungsgegenstandEnmList?.length > 0) {
        this.aueLeistungsgegenstandEnmList.forEach((item: any) => {
          item.enmValue = enmIdentsArray.includes(String(item.enmIdent));
        });
      }
    }
  }

  openFileOverview(): void {
    this.appSvc.Document.Manager.OpenOverlay({auID: this.CaseSummary?.caseDetails?.data?.auID, Events: this.Events});
  }

  openReportBuilder(): void {
    this.appSvc.ReportBuilder.DocBuilder.OpenTab(
      {auID: this.CaseSummary?.caseDetails?.data?.auID, Events: this.Events});
  }


  OpenDetailHistoryModal(): void {
    if (!this.caseTable.isLoading
      && this.caseTable.selectedRow[this.caseTable.selectKey]) {
      this.modal
        .show('ModalDetailHistoryComponent', {ID: this.caseTable.selectedRow[this.caseTable.selectKey]})
        .subscribe(() => {});
    }
  }

  async openWorkspace(index?: number): Promise<void> {
    this.appSvc.Case.Workspace.OpenTab(this.CaseSummary.caseDetails.data.auID, {Events: this.Events});
  }

  inputChanged(input: string, inputType: string, value: any): void {
    if (!value && inputType === 'number') {
      this.uiModel[input] = 0;
    } else if (isNaN(value) && inputType === 'date') {
      this.uiModel[input] = undefined;
    } else {
      this.uiModel[input] = value;
    }
  }


  saveReportFolderStates(sources: string[]): void {
    this.openReportFolder = sources;
  }

  saveAttachmentFolderStates(sources: string[]): void {
    this.openAttachmentFolder = sources;
  }
}
